<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-item label="计划分类 " prop="plan">
                <a-select v-model="queryParam.plan" placeholder="请选择计划分类" allow-clear>
                  <a-select-option value="1">计划一</a-select-option>
                  <a-select-option value="2">计划二</a-select-option>
                  <a-select-option value="3">计划三</a-select-option>
                  <a-select-option value="4">计划四</a-select-option>
                  <a-select-option value="5">计划五</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template v-if="advanced">


            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['insurance:insurance:add']">
          <a-icon type="plus" />新增
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['insurance:insurance:edit']">
          <a-icon type="edit" />修改
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['insurance:insurance:remove']">
          <a-icon type="delete" />删除
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['insurance:insurance:edit']">
            <a-icon type="edit" />修改
          </a>
          <a-divider type="vertical" v-hasPermi="['insurance:insurance:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['insurance:insurance:remove']">
            <a-icon type="delete" />删除
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageInsurance,listInsurance, delInsurance } from '@/api/insurance/insurance'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'Insurance',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        name: null,
        type: null,
        plan: undefined,
        dayMin: null,
        dayMax: null,
        money: null,
        totalMoney: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          width: 80,
          align: 'center',
          customRender: (text, record, index) => index + 1
        },
        {
          title: '方案名称',
          dataIndex: 'name',
          width: 120,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保险分类',
          dataIndex: 'type',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return 'A类'
            }else if(f == 2){
              return 'B类'
            }else if(f == 3){
              return 'C类'
            }else if(f == 4){
              return 'D类'
            }

          }
        },
        {
          title: '计划分类',
          dataIndex: 'plan',
          ellipsis: true,
          align: 'center',
          customRender(f){
            if(f == 1){
              return '计划一'
            }else if(f == 2){
              return '计划二'
            }else if(f == 3){
              return '计划三'
            }else if(f == 4){
              return '计划四'
            }else if(f == 5){
              return '计划五'
            }
          }
        },
        {
          title: '最小天数',
          dataIndex: 'dayMin',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最大天数',
          dataIndex: 'dayMax',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保险费用每天',
          width: 120,
          dataIndex: 'money',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '保险总费用',
          dataIndex: 'totalMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '意外身故',
          dataIndex: 'die',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '意外医疗',
          dataIndex: 'medical',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '住院津贴',
          dataIndex: 'allowance',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '意外险注意事项',
          dataIndex: 'mattersNeedAttention',
          width: 160,
          ellipsis: true,
          align: 'center'
        },
        {
          title: '插入时间',
          dataIndex: 'createTime',
          width: 150,
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    /** 查询保险价格列表 */
    getList () {
      this.loading = true
     pageInsurance(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        name: undefined,
        type: undefined,
        plan: undefined,
        dayMin: undefined,
        dayMax: undefined,
        money: undefined,
        totalMoney: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中编号为' + ids + '的数据',
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delInsurance(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                '删除成功',
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据而非选中数据',
        onOk () {
          that.download('insurance/insurance/export', {
            ...that.queryParam
          }, `保险价格_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
